// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"b9f21cb7","453":"a5979135"}[chunkId] + ".chunk.js";
};